import { useCallback } from 'react';
import {
  LabelValueDetailsInput,
  TimeSignalClassification
} from 'graphql/types';
import { useBulkUpdateTimeSignals } from '../../hooks/useBulkUpdateTimeSignals';

export type MultiEditActionArgs = {
  selectedNotes: string[];
  unSelectedNotes?: string[];
  classificationTarget: TimeSignalClassification;
  labelValues?: LabelValueDetailsInput[];
  isAllSelected: boolean;
};
export type HandleMultiEditActionCallback = ({
  labelValues,
  classificationTarget,
  selectedNotes,
  unSelectedNotes,
  isAllSelected
}: MultiEditActionArgs) => Promise<void>;

type ReturnType = {
  handleMultiEditAction: HandleMultiEditActionCallback;
  isActionInProgress: boolean;
};

export const useMultiEditActions = (): ReturnType => {
  const {
    onMultiEditTimeSignals,
    updateInProgress
  } = useBulkUpdateTimeSignals();

  const handleMultiEditAction = useCallback(
    async ({
      selectedNotes,
      unSelectedNotes,
      labelValues,
      classificationTarget
    }: MultiEditActionArgs) => {
      await onMultiEditTimeSignals({
        unSelectedNoteIds: unSelectedNotes ?? [],
        selectedNoteIds: selectedNotes,
        labelValues: labelValues,
        classificationTarget: classificationTarget
      });
    },
    [onMultiEditTimeSignals]
  );
  return {
    handleMultiEditAction: handleMultiEditAction,
    isActionInProgress: updateInProgress
  };
};
